import { PayloadAction, Reducer, configureStore } from "@reduxjs/toolkit";
import { rtkQueryErrorLogger } from "Middleware";
import { baseApi, injectStore } from "Services";
import { resetStoreAction } from "Utils";
import { RootState, rootReducer } from "./rootReducer";

const appReducer: Reducer<RootState, PayloadAction> = (state, action) => {
  if (resetStoreAction.match(action)) {
    // Keep API state, only reset UI data
    const selectiveState = {
      [baseApi.reducerPath]: state?.[baseApi.reducerPath],
    } as unknown as RootState;

    return rootReducer(selectiveState, action);
  }

  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: appReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([baseApi.middleware, rtkQueryErrorLogger]),
});

injectStore(store);

export type { RootState };
export type StoreType = typeof store;
export type AppDispatch = typeof store.dispatch;
